import { Component, EventEmitter, Injector, OnInit, Output } from "@angular/core";
import { AppComponentBase } from "@shared/app-component-base";
import { AgendaServiceProxy, CreateAgendaDto, DayOfWeek, EssentialProfisisonalSaudeDto, Int32NameValueDto, ProfissionalSaudeServiceProxy, TipoSala } from "@shared/service-proxies/service-proxies";
import { BsModalRef } from 'ngx-bootstrap/modal';
import { finalize } from 'rxjs/operators';
import {DuracaoConsultaModel} from '@shared/model/duracao-consulta.model';
import { Subscription } from "@node_modules/rxjs";

@Component({
    templateUrl: './create-agenda.component.html',
    styleUrls: ['./create-agenda.component.scss'],
})
export class CreateAgendaComponent extends AppComponentBase implements OnInit {
    protected title: string = "Criar nova sala";
    protected subtitle: string = "Crie uma nova sala para gerenciar agendamentos";
    protected saving: boolean = false;
    protected profissionais: EssentialProfisisonalSaudeDto[] = [];
    protected profissionaisSelecionados: EssentialProfisisonalSaudeDto[] = [];
    protected profissionaisFiltrados: EssentialProfisisonalSaudeDto[] = [];
    protected agenda: CreateAgendaDto = new CreateAgendaDto();
    protected nome: string = '';
    public tempoConsultas = DuracaoConsultaModel;
    protected diasDaSemana: Int32NameValueDto[];
    protected diasSelecionados: DayOfWeek[] = [];
    protected TipoSala = TipoSala;

    @Output() onSave = new EventEmitter<any>();

    constructor(
        injector: Injector,
        private _agendaService: AgendaServiceProxy,
        private _profissionalAppService: ProfissionalSaudeServiceProxy,
        public bsModalRef: BsModalRef
    ) {
        super(injector)
    }

    ngOnInit(): void {
        if (this.appSession.clinicaId == null) {
            this.getProfissional();
        } else {
            this.getProfissionais();
        }

        this.getDiasDaSemana();
    }

    protected atualizarLista(nome: string) {
        if (!nome) {
            this.profissionaisFiltrados = [];
        } else {
            this.profissionaisFiltrados = this.profissionais
                .filter(x => x.nome.toLowerCase().includes(nome.toLowerCase()))
                .filter(x => this.profissionaisSelecionados.every(y => y.id !== x.id));
        }
    }

    protected insertProfissional(profissional: EssentialProfisisonalSaudeDto): void {
        if (this.profissionaisSelecionados.find(x => x.id == profissional.id)) return;

        this.profissionaisSelecionados.push(profissional);

        this.profissionaisFiltrados = [];
        this.nome = '';
    }

    protected removeProfissional(profissional: EssentialProfisisonalSaudeDto): void {
        this.profissionaisSelecionados = this.profissionaisSelecionados.filter(x => x.id != profissional.id);
    }

    protected save(): void {
        if(this.diasSelecionados.length == 0){
            abp.message.info("Selecione pelo menos um dia!");
            return;
        }

        if(!this.agenda.duracaoConsulta){
            abp.notify.warn("Informe a duração das consultas");
        }

        this.saving = true;
        this.agenda.profissionaisIds = this.profissionaisSelecionados.map(i => i.id);
        this.agenda.clinicaId = this.appSession.clinicaId;
        this.agenda.diasDaSemana = this.diasSelecionados;

        abp.ui.setBusy();
        this._agendaService.create(this.agenda)
            .pipe(
                finalize(() => {
                    abp.ui.clearBusy();
                    this.saving = false;
                })
            )
            .subscribe(() => {
                this.onSave.emit();
                this.bsModalRef.hide();
            })
    }

    private getProfissionais(): void {
        abp.ui.setBusy();
        this._profissionalAppService.getProfissionaisByClinica(this.appSession.clinicaId).pipe(
            finalize(() => {
                abp.ui.clearBusy();
            })
        ).subscribe((result) => {
            this.profissionais = result;
        })
    }

    private getProfissional(): void {
        abp.ui.setBusy();
        this._profissionalAppService.get(this.appSession.profissionalId).pipe(
            finalize(() => {
                abp.ui.clearBusy();
            })
        ).subscribe((result) => {
            let profissional = new EssentialProfisisonalSaudeDto();
            profissional.cpf = result.cpf;
            profissional.id = result.id;
            profissional.nome = result.nome
            this.insertProfissional(profissional);
        })
    }

    private getDiasDaSemana(): Subscription {
        abp.ui.setBusy();
        return this._agendaService
            .getDaysOfWeek()
            .pipe(
                finalize(() => {
                    abp.ui.clearBusy()
                })
            )
            .subscribe((result: Int32NameValueDto[]) => {
                this.diasDaSemana = result;
            });
    }

    protected selectedDia(dia) {
        if (this.diasSelecionados.some(x => x == dia))
            this.diasSelecionados = [...this.diasSelecionados.filter(x => x != dia)];
        else
            this.diasSelecionados.push(dia);
    }
}
